
import { isFeatureEnabled } from '@/config/featureFlags';
import { SocialAccountsManager } from '../SocialAccountsManager';
import { ConnectedAppsIcons } from '../social/ConnectedAppsIcons';

interface SocialAccountsFeatureSectionProps {
  isEditMode: boolean;
}

export const SocialAccountsFeatureSection = ({ isEditMode }: SocialAccountsFeatureSectionProps) => {
  const socialAccountsEnabled = isFeatureEnabled('SOCIAL_ACCOUNTS_MANAGER');

  if (!socialAccountsEnabled) {
    return (
      <div className="bg-red-100 p-4 rounded-lg border-2 border-red-300">
        <p className="text-sm text-red-800 mb-2 font-semibold">
          ❌ FEATURE DISABLED: Social Accounts Manager
        </p>
        <p className="text-xs text-red-600">
          Enable it using the Feature Flag Controller in the bottom-left corner
        </p>
      </div>
    );
  }

  // In edit mode, show the full Social Accounts Manager
  if (isEditMode) {
    return (
      <div className="p-3 rounded border bg-green-50 border-green-200">
        <p className="text-xs mb-2 font-medium text-green-700">
          ✅ Social Accounts Manager
        </p>
        <SocialAccountsManager />
      </div>
    );
  }

  // In view mode, show only the condensed connected apps icons
  return (
    <div className="p-3 rounded border bg-blue-50 border-blue-200">
      <p className="text-xs mb-2 font-medium text-blue-700">
        ✅ Social Accounts (View Mode)
      </p>
      <ConnectedAppsIcons />
    </div>
  );
};
